import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import { CurrencyPipe } from '@angular/common';

/**
 * @ngModule SharedModule
 * @whatItDoes Formats a number as currency using locale rules.
 * @howToUse `number_expression | ulticurrency[:digitInfo[:currencyCode]]`
 * @description
 *
 * Use `ulticurrency` to format a number as currency.
 * This defaults to the current locale and is set to always show the currency symbol.
 * This adds a space after the dollar sign, as the built in currencyPipe does not.
 *
 * - `digitInfo` See {@link DecimalPipe} for detailed description.
 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
 *    as `USD` for the US dollar and `EUR` for the euro.
 * ### Example
 *
 * {@example common/pipes/ts/currency_pipe.ts region='CurrencyPipe'}
 */
@Pipe({
  name: 'ulticurrency'
})
export class UltiCurrencyPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private _locale: string, private currencyPipe: CurrencyPipe) {}

  transform(value: any, digits: string, currencyCode?: string, forceFractionalValue?: boolean): string {
    if (!forceFractionalValue && Math.abs(value) >= 1) {
      value = Math.trunc(value);
    }

    if (!currencyCode) {
      currencyCode = 'USD';
    }
    let result = this.currencyPipe.transform(value, currencyCode, 'symbol', digits, this._locale);
    if (result && result.charAt(0) === '$') {
      result = result.replace('$', '$ ');
    }
    return result;
  }

}
